/**
 * KAN-811: настройка "Менеджер видит клиентов" для менеджеров со входом в
 * кабинет: "Свои и ничьи" (по умолчанию) или "Все клиенты кабинета".
 * Сохраняется кнопкой организации (SettingsPage).
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { NativeSelect } from '@/components/ui/native-select';
import {
  DEFAULT_MANAGER_VISIBILITY,
  MANAGER_VISIBILITY_OPTIONS,
  type ManagerVisibility,
} from '@/types/settings';

interface Props {
  value: ManagerVisibility | undefined;
  onChange: (value: ManagerVisibility) => void;
  disabled: boolean;
}

const SELECT_ID = 'manager-visibility';

export function ManagerVisibilitySetting({ value, onChange, disabled }: Props): JSX.Element {
  return (
    <Card data-testid="manager-visibility-settings">
      <CardHeader>
        <CardTitle className="text-lg">Менеджеры</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <Label htmlFor={SELECT_ID}>Менеджер видит клиентов</Label>
        <NativeSelect
          id={SELECT_ID}
          data-testid="manager-visibility-select"
          options={[...MANAGER_VISIBILITY_OPTIONS]}
          value={value ?? DEFAULT_MANAGER_VISIBILITY}
          onChange={(e) => onChange(e.target.value as ManagerVisibility)}
          disabled={disabled}
          className="sm:max-w-xs"
        />
        <p className="text-xs text-gray-500">
          "Свои и ничьи": менеджер не видит клиентов, закреплённых за другими менеджерами.
        </p>
      </CardContent>
    </Card>
  );
}
